export default "__VITE_ASSET__DvT4x$Lh__"